import React, { useState, useRef } from 'react';
import {func} from 'prop-types';
import classnames from 'classnames';

import {onlineHubHost} from '../../config';

import CustomInput from '../CustomInput';
import Arrow from '../Arrow';
import { ErrorMessage } from '../Message/Message';

import './Login.css';

const isValidEmail = (string = '') => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(string);

export default function Login({onSuccess}) {
  const passwordRef = useRef(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailValidated, setEmailValidated] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginStatus, setLoginStatus] = useState('pending');
  const [invalidCredentials, setInvalidCredentials] = useState(false);

  function getCurrentLogo() {
    return `./static/images/${loginStatus === 'success'
      ? 'logo-green'
      : loginStatus === 'failed'
        ? 'logo-red'
        : 'logo'}.png`;
  }

  function handleEmailChange({target: {value}}) {
    setEmail(value);
  }

  function handleEmailKeyPress(event) {
    if (event.key === 'Enter') {
      if (event.preventDefault) {
        event.preventDefault();
      }
      const isEmailValid = isValidEmail(email);
      setEmailValidated(isEmailValid);
      setEmailError(!isEmailValid);
      if (isEmailValid) {
        passwordRef.current.focus();
      }
    }
  }

  function handleSubmit(ev) {
    ev.preventDefault();

    if (!password.length) {
      setPasswordError(true);
    } else {
      setLoading(true);
      fetch(`${onlineHubHost}/app/login`, {
        method: 'post',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({email, password})
      })
      .then((res) => {
        setLoading(false);
        if (res.ok) {
          setLoginStatus('success');
          return res.json();
        }
        setInvalidCredentials(true);
        setLoginStatus('failed');
        return null;
      })
      .then((body) => {
        if (body) {
          localStorage.setItem('token', body.token);
        }
        onSuccess(!!body);
      })
      .catch(() => {
        setLoginStatus('failed');
      })
    }
  }

  return (
    <div className="Login">
      <img className="Login-logo" src={getCurrentLogo()} alt="logo" />
      <h1>
        Sign in to Online Device Hub
      </h1>
      <form className="Login-form" onSubmit={handleSubmit} noValidate>
        <div className="Login-form-formBlock">
          <CustomInput
            type="email"
            name="email"
            value={email}
            error={!!emailError || invalidCredentials}
            onChange={handleEmailChange}
            onKeyPress={handleEmailKeyPress}
            placeholder="Email address"
            autoFocus
            disabled={loading}
          />
          {!emailValidated && <Arrow onClick={() => handleEmailKeyPress({key: 'Enter'})} />}
          {emailError && <ErrorMessage>Please enter a valid email address</ErrorMessage>}
        </div>
        <div className={classnames('Login-form-formBlock', {'Login-form-formBlock-hidden': !emailValidated})}>
          <CustomInput
            ref={passwordRef}
            type="password"
            name="password"
            value={password}
            error={!!passwordError || invalidCredentials}
            onChange={({target: {value}}) => setPassword(value)}
            placeholder="Password"
            disabled={loading}
          />
          {emailValidated && <Arrow type="submit" loading={loading} />}
          {passwordError && <ErrorMessage>{passwordError}</ErrorMessage>}
        </div>
      </form>
      {invalidCredentials && <ErrorMessage>Login failed, please verify your credentials</ErrorMessage>}
    </div>
  )
}

Login.propTypes = {
  onSuccess: func
}
